// extracted by mini-css-extract-plugin
module.exports = {"flightInfoLine":"FlightInfoLine_flightInfoLine__LwnHe","leftLocationTime":"FlightInfoLine_leftLocationTime__2EMFN"};